module.exports = __webpack_public_path__ + "static/media/portrait-footer.03fc2010.png";